<template>
  <div id="topDiv">
    <div class="col-lg-12 col-md-12" v-if="!$auth.user().subscription">
      <card :class="'bg-card-'+theme">
        <div class="card-header">
          <h4 class="card-title">
            <i class="nc-icon nc-notification-70"></i> Oops!
          </h4>
        </div>
        <hr>
        <div class="card-body">
          <div class="text-center">
            <h2 class="card-title text-center">
              <small>Wall Street, we have a problem...</small>
            </h2>
            <h2 class="card-title text-center">
              <small>Você não possui assinatura ativa para continuar acompanhando os Cursos.</small>
            </h2>
            <br>
            <router-link
              class="btn btn-round btn-fill"
              :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
              to="/signature"
              href="/performance"
            >Nova Assinatura</router-link>
          </div>
        </div>
      </card>
    </div>
    <div v-else>
      <!-- Todos os cursos do Usuário -->
      <div class="row" v-if="open==='ListCourses'">
        <div class="col-md-4" v-for="(course, index) in courses" :key="course.id">
          <div class="row" v-if="loadingCourses" v-loading="loadingCourses" id="loading"></div>
          <div v-if="!loadingCourses" :class="'bg-card-'+theme" class="card-header d-flex justify-content-center" slot="image" @click.prevent="openCourse(index)">
            <img class="col-md-10 justify-content-center" :src="course.img_link" alt="..." style="cursor: pointer;">
          </div>
          <br>
        </div>
      </div>

      <!-- Cursos em Collapse -->

      <div class="row" v-if=" open==='ShowCourse'">
        <div class="col-xl-12 col-lg-12">
          <card :class="'bg-card-'+theme">
            <div class="text-center">
              <h3>Bem-vindo ao curso de {{ courses[courseIndex].name }}</h3>
            </div>
            <div>
              <p class="card-title">Confira seu progresso:</p>
              <l-progress
                :values="[{type:'success', text:courseProgress + ' %', value:courseProgress}]"
                :height="18"
              ></l-progress>
              <div class="row">
                <div class="col-md-10">
                  <div v-if="sequence.chapterIndex !== -1">
                    <h4
                      class="lead"
                      style="margin-top: 0px;"
                    >Atualmente você está no {{ sequence.chapterIndex }} capítulo: {{ courses[courseIndex].chapters.data[sequence.chapterIndex].title }}</h4>
                  </div>
                  <div v-else>
                    <h4 class="lead" style="margin-top: 0px;">Parabéns, você finalizou o curso</h4>
                    <a
                      class="btn btn-round text-white"
                      :class=" theme === 'black' ? 'btn-azure':'btn-primary' "
                      @click.prevent="fetchUserCourses()"
                    >
                      <i class="nc-icon nc-bullet-list-67"></i> Todos os Cursos
                    </a>
                  </div>
                </div>
                <div class="col-md-2">
                  <button
                    class="btn btn-round"
                    :class=" theme === 'black' ? 'btn-azure':'btn-primary' "
                    type="submit"
                    @click="downloads()"
                  >Downloads</button>
                  <el-dialog
                    center
                    title="Ferramentas para Downloads"
                    :visible.sync="modals.centered"
                  >
                    <card>
                      <span
                        v-if="!courses[courseIndex].tools.data.length"
                      >Não há downloads para este curso.</span>
                      <div class="table-responsive" v-if="courses[courseIndex].tools.data.length">
                        <table class="table">
                          <tr>
                            <th>#</th>
                            <th>Ferramenta</th>
                            <th>Download</th>
                          </tr>
                          <tr
                            v-for="(tool, toolIndex) in courses[courseIndex].tools.data"
                            :key="tool.id"
                          >
                            <td>{{ toolIndex + 1 }}</td>
                            <td>{{ tool.name }}</td>
                            <td>
                              <a class="btn btn-round btn-fill" :href="tool.link" target="_blank">
                                <i class="nc-icon nc-cloud-download-93"></i>
                              </a>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </card>
                  </el-dialog>
                </div>
              </div>
            </div>
            <div class="text-center" v-if="sequence.chapterIndex !== -1">
              <h4 class="lead text-center">Continuar na sequencia de vídeos:</h4>
              <h6>{{ courses[courseIndex].chapters.data[sequence.chapterIndex].lessons.data[sequence.lessonIndex].title }}</h6>
              <br>
              <button
                class="btn btn-primary btn-round"
                v-if="theme === 'light'"
                type="button"
                @click="playLesson(courses[courseIndex].chapters.data[sequence.chapterIndex].lessons.data[sequence.lessonIndex],
                                    sequence.lessonIndex, courses[courseIndex].chapters.data[sequence.chapterIndex].lessons.data,
                                    sequence.chapterIndex, courses[courseIndex].chapters.data)"
              >
                <i class="fa fa-play"></i>
              </button>
              <button
                class="btn btn-azure2 btn-round"
                v-if="theme === 'black'"
                type="button"
                @click="playLesson(courses[courseIndex].chapters.data[sequence.chapterIndex].lessons.data[sequence.lessonIndex],
                                    sequence.lessonIndex, courses[courseIndex].chapters.data[sequence.chapterIndex].lessons.data,
                                    sequence.chapterIndex, courses[courseIndex].chapters.data)"
              >
                <i class="fa fa-play"></i>
              </button>
            </div>
          </card>
        </div>
      </div>

      <div class="row" v-if=" open==='ShowCourse'">
        <div class="col-xl-12 col-lg-12">
          <card :class="'bg-card-'+theme">
            <div class="card" :class="'bg-card-'+theme">
              <el-collapse
                class="table-responsive"
                v-for="(chapter, chapterIndex) in courses[courseIndex].chapters.data"
                :key="chapter.id"
                v-if="chapter.lessons.data.length"
                name="1"
              >
                <el-collapse-item
                  class=""
                  :class="'el-collapse-item__header-'+theme"
                  :title="'Capítulo ' + chapter.number +  ' - ' + chapter.title"
                  height="auto"
                  name="1"
                >
                  <div class="table overflow-auto" :class="'card-title-'+theme">
                    <tr>
                      <th width="50%">Aula</th>
                      <th width="15%">Concluído ?</th>
                      <th width="15%">Obrigatória ?</th>
                      <th width="15%">Duração</th>
                      <th width="5%"></th>
                    </tr>
                    <tr v-for="(lesson, lessonIndex) in chapter.lessons.data" :key="lesson.id">
                      <td width="50%">{{ lesson.title }}</td>
                      <td width="15%">
                        <i :class="lesson.watched ? 'fa fa-check' : ''" style="color: #0976b4;"></i>
                      </td>
                      <td width="15%">{{ lesson.required ? 'Sim' : 'Não' }}</td>
                      <td width="15%">{{ lesson.duration }} min.</td>
                      <td width="5%">
                        <button
                          v-if=" (chapterIndex <= sequence.chapterIndexNoOpcional && lessonIndex <= sequence.lessonIndexNoOpcional) || sequence.chapterIndexNoOpcional === -1"
                          class="btn btn-round btn-fill"
                          :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                          type="button"
                          @click="playLesson(lesson, lessonIndex, chapter.lessons.data,
                            chapterIndex, courses[courseIndex].chapters.data)"
                        >
                          <i class="fa fa-play"></i>
                        </button>
                        <button
                          v-else
                          class="btn btn-round btn-fill"
                          :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                          type="button"
                          :disabled="!tempWatchedLesson"
                        >
                          <i class="fa fa-lock"></i>
                        </button>
                      </td>
                    </tr>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </card>
        </div>
      </div>

      <!-- Curso Solicitado ao Usuário -->
      <card
        v-if="open==='playLesson'"
        class=" col-lg-12 col-md-12 col-sm-12 "
        :class="'bg-card-'+theme"
      >
        <div class="text-center">
          <h4>
            <i class="nc-icon nc-tv-2"></i>
            Aula {{ watchLesson.seq_number }} - {{ watchLesson.title }}
          </h4>
        </div>
        <div class="row">
          <div class="row col-lg-12 col-md-12 col-sm-12 text-center">
            <div class="col-lg-4 col-md-4 col-sm-4">
              <button
                class="btn btn-azure2"
                v-if="lessonIndex !== 0 && theme === 'black'"
                @click="playLesson(lessonsData[lessonIndex -1], lessonIndex -1, lessonsData, chapterIndex, chaptersData)"
              >
                <i class="fas fa-arrow-left"></i>
                Aula Anterior
              </button>
              <button
                class="btn"
                v-if="lessonIndex !== 0 && theme === 'light'"
                @click="playLesson(lessonsData[lessonIndex -1], lessonIndex -1, lessonsData, chapterIndex, chaptersData)"
              >
                <i class="fas fa-arrow-left"></i>
                Aula Anterior
              </button>
            </div>
            <!-- Button All Vídeos -->
            <div class="col-lg-4 col-md-4 col-sm-4">
              <button
                class="btn"
                :class=" theme === 'black' ? 'btn-azure2':'btn-primary' "
                @click.prevent="openCourse(courseIndex)"
              >
                <i class="fas fa-bars"></i>
                Todos os Vídeos
              </button>
            </div>
            <!-- Button Black -->
            <div class="col-lg-4 col-md-4 col-sm-4">
              <button
                class="btn btn-azure2"
                v-if="lessonIndex + 1 !== lessonsData.length && theme === 'black' "
                :disabled="!tempWatchedLesson"
                @click="playLesson(lessonsData[lessonIndex+1], lessonIndex+1, lessonsData, chapterIndex, chaptersData)"
              >
                Próxima aula
                <i class="fas fa-arrow-right"></i>
              </button>
              <button
                class="btn btn-azure2"
                v-else-if="lessonIndex + 1 === lessonsData.length && chaptersData.length > chapterIndex +1 && theme === 'black'"
                :disabled="!tempWatchedLesson"
                @click="playLesson(chaptersData[chapterIndex+1].lessons.data[0], 0, chaptersData[chapterIndex+1].lessons.data, chapterIndex + 1, chaptersData)"
              >
                Próximo Capítulo
                <i class="fas fa-arrow-right"></i>
              </button>
              <button
                class="btn btn-azure2"
                v-else-if="lessonIndex + 1 === lessonsData.length && chaptersData.length === chapterIndex +1 && theme === 'black'"
                :disabled="!tempWatchedLesson"
                @click.prevent="fetchUserCourses()"
              >Fim do curso</button>
              <!-- Button light -->
              <button
                class="btn"
                v-if="lessonIndex + 1 !== lessonsData.length && theme === 'light'"
                :disabled="!tempWatchedLesson"
                @click="playLesson(lessonsData[lessonIndex+1], lessonIndex+1, lessonsData, chapterIndex, chaptersData)"
              >
                Próxima aula
                <i class="fas fa-arrow-right"></i>
              </button>
              <button
                class="btn"
                v-else-if="lessonIndex + 1 === lessonsData.length && chaptersData.length > chapterIndex +1  && theme === 'light'"
                :disabled="!tempWatchedLesson"
                @click="playLesson(chaptersData[chapterIndex+1].lessons.data[0], 0, chaptersData[chapterIndex+1].lessons.data, chapterIndex + 1, chaptersData)"
              >
                Próximo Capítulo
                <i class="fas fa-arrow-right"></i>
              </button>
              <button
                class="btn"
                v-else-if="lessonIndex + 1 === lessonsData.length && chaptersData.length === chapterIndex +1 && theme === 'light'"
                :disabled="!tempWatchedLesson"
                @click.prevent="fetchUserCourses()"
              >Fim do curso</button>
            </div>
          </div>
          <iframe id="lessonFrame" :src="watchLesson.link" frameborder="0" allow="autoplay;fullscreen;encrypted-media" allowfullscreen></iframe>
        </div>
      </card>

      <card v-if="open==='playLesson'" :class="'bg-card-'+theme">
        <div class="row">
          <div class="col-lg-8 col-md-8">
            <vue-tabs>
              <v-tab title="Conteúdo" icon="nc-icon nc-single-copy-04">
                <h5 class="content-video" v-html="watchLesson.description"></h5>
              </v-tab>
            </vue-tabs>
          </div>
          <div class="col-lg-4 col-md-4">
            <div class="col-lg-6 col-md-6 text-center">
              <h5 class="text-center">Classifique esta aula</h5>
              <div class="col-lg-6 col-md-6 btn-group">
                <button
                  class="col-lg-3 col-md-3 btn-azure2 btn-fill btn-round"
                  type="button"
                  @click.prevent="reviewLesson(watchLesson, 1)"
                  :class="tempReviewLesson === 1 ? 'btn-sm btn-warning ' : 'btn-sm btn-warning btn-outline'"
                >
                  <i class="fa fa-angry"></i>
                </button>
                <button
                  class="col-lg-3 col-md-3 btn-azure2 btn-fill btn-round"
                  type="button"
                  @click.prevent="reviewLesson(watchLesson, 2)"
                  :class="tempReviewLesson === 2 ? 'btn-sm btn-warning' : 'btn-sm btn-warning btn-outline'"
                >
                  <i class="fa fa-meh"></i>
                </button>
                <button
                  class="col-lg-3 col-md-3 btn-azure2 btn-fill btn-round"
                  type="button"
                  @click.prevent="reviewLesson(watchLesson, 3)"
                  :class="tempReviewLesson === 3 ? 'btn-sm btn-warning' : 'btn-sm btn-warning btn-outline'"
                >
                  <i class="fa fa-laugh-beam"></i>
                </button>
                <button
                  class="col-lg-3 col-md-3 btn-azure2 btn-fill btn-round"
                  type="button"
                  @click.prevent="reviewLesson(watchLesson, 4)"
                  :class="tempReviewLesson === 4 ? 'btn-sm btn-warning' : 'btn-sm btn-warning btn-outline'"
                >
                  <i class="fa fa-grin-hearts"></i>
                </button>
              </div>
            </div>
            <hr>
            <div class="col-lg-6 col-md-6">
              <button
                type="button"
                class="col-md-6"
                :class=" tempWatchedLesson ? 'btn btn-round text-white' : 'btn btn-warning btn-round text-gray'"
                :disabled="tempWatchedLesson"
                @click.prevent="tempWatchedLesson ? '' : markLesson(watchLesson)"
              >
                <span class="btn-label">
                  <i v-if="!tempWatchedLesson" class="fa fa-circle"></i>
                  <i v-if="tempWatchedLesson" class="fa fa-check"></i>
                </span>
                {{ tempWatchedLesson ? 'Concluída' : 'Concluir'}}
              </button>
            </div>
          </div>
        </div>
      </card>

      <el-dialog center title="Questionário" :visible.sync="modals.centered">
        <div align="center"><p>Acerte 80% para ser aprovado</p></div><br />
        <form @submit.prevent="answerQuestions(watchLesson)" method="post">
          <div v-for="(question, index) in this.questions" :key="question.id">
            <p style="white-space: pre-wrap; word-break: keep-all;">{{question.sentence}}</p>
            <label class="radio-inline" style="margin-right:10px">
              <input type="radio" v-model="answers[question.id]" value="1"/> Verdadeiro
            </label>
            <label class="radio-inline">
              <input type="radio" v-model="answers[question.id]" value="0"/> Falso
            </label>
            <hr />
          </div>
          <div align="center">
            <br /><button type="submit" title="Responder" class="col-lg-3 col-md-3 btn-success btn-fill btn-round btn-outline">Responder</button>
          </div>
        </form>
      </el-dialog>

      <el-dialog center :visible.sync="modals.result">
        <div id="result" align="center"><h4>{{this.result}}</h4></div><br />
        <div align="center">
          <br /><button title="finalizar" @click.prevent="closeModal('result')" class="col-lg-3 col-md-3 btn-success btn-fill btn-round btn-outline">OK!</button>
        </div>
      </el-dialog>

      <!-- <card v-if="open==='playLesson'" :class="'bg-card-'+theme">
        <div class="col-lg-12 col-md-12">
          <h4>
            Deixe seu comentario
            <i class="fa fa-comment-dots"></i>
          </h4>
          <div>
            <fg-input placeholder="Simple input with v-model binding"></fg-input>
          </div>
          <button class="btn btn-azure btn-fill" v-if="theme === 'black'">
            <i class="fa fa-check"></i> Enviar
          </button>
          <button class="btn btn-outline btn-round" v-if="theme === 'light'">
            <i class="fa fa-check"></i> Enviar
          </button>
        </div>
      </card> -->
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Loading, Dialog, Table, TableColumn } from "element-ui";
import VueTabs from "vue-nav-tabs";
import { Progress as LProgress } from "src/components/index";
import { Collapse, CollapseItem } from "element-ui";
import _ from "lodash";
import swal from "sweetalert2";

Vue.use(Loading.directive, VueTabs);

export default {
  components: {
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn, LProgress,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  data() {
    return {
      modals: {
        centered: false,
        result: false
      },
      answers: {},
      questions: [],
      question: {
        sentence: "",
        answer: "",
        chapter_id: "",
        lesson_id: ""
      },
      result: "",
      open: "ListCourses",
      loadingCourses: true,
      tempWatchedLesson: false,
      tempReviewLesson: 0,
      courseProgress: 27,
      courseIndex: 0,
      watchLesson: {
        title: "",
        seq_number: 0,
        duration: "",
        link: "",
        watched: "",
        review: ""
      },
      courses: [],
      lessonIndex: 0,
      lessonsData: [],
      chapterIndex: 0,
      chaptersData: []
    };
  },
  methods: {
    openModal(name) {
      this.modals[name] = true;
    },
    closeModal(name) {
      this.modals[name] = false;
    },
    fetchUserCourses() {
      this.loadingCourses = true;
      this.axios
        .get("/courses")
        .then(response => {
          this.courses = response.data.data;
          this.loadingCourses = false;
          this.listCourses();
        })
        .catch(error => {
          this.result = "Erro ao carregar Cursos. Tente novamente. \n " + error;
          this.openModal('result');
          console.log(error);
          this.loadingCourses = false;
        });
    },

    reFetchUserCourses() {
      this.loadingCourses = true;
      this.axios
        .get("/courses")
        .then(response => {
          this.courses = response.data.data;
          this.courseProgress = (
            (this.courses[this.courseIndex].chapters.data
                .map(
                  chapter =>
                    chapter.lessons.data.filter(lesson => lesson.watched).length
                )
                .reduce((accumulator, currentValue) => {
                  return accumulator + currentValue;
                }, 0) /
              this.courses[this.courseIndex].chapters.data
                .map(chapter => chapter.lessons.data.length)
                .reduce((accumulator, currentValue) => {
                  return accumulator + currentValue;
                }, 0)) *
            100
          ).toFixed(0);
          this.loadingCourses = false;
        })
        .catch(error => {
          this.result = "Erro ao recarregar cursos. Tente novamente. \n " + error;
          this.openModal('result');
          console.log(error);
          this.loadingCourses = false;
        });
    },
    listCourses() {
      this.open = "ListCourses";
    },
    openCourse(index) {
      this.open = "ShowCourse";
      this.courseIndex = index;
      this.courseProgress = (
        (this.courses[this.courseIndex].chapters.data
            .map(
              chapter =>
                chapter.lessons.data.filter(lesson => lesson.watched).length
            )
            .reduce((accumulator, currentValue) => {
              return accumulator + currentValue;
            }, 0) /
          this.courses[this.courseIndex].chapters.data
            .map(chapter => chapter.lessons.data.length)
            .reduce((accumulator, currentValue) => {
              return accumulator + currentValue;
            }, 0)) *
        100
      ).toFixed(0);
    },
    playLesson(lesson, lessonIndex, lessons, chapterIndex, chapters) {
      this.lessonIndex = lessonIndex;
      this.lessonsData = lessons;
      this.watchLesson = lesson;
      this.chapterIndex = chapterIndex;
      this.chaptersData = chapters;
      this.tempWatchedLesson = this.watchLesson.watched;
      this.tempReviewLesson = this.watchLesson.review;
      this.open = "playLesson";

      // Scroll to top
      var element = document.getElementById("topDiv");
      var top = element.offsetTop;
      window.scrollTo(0, top);
    },
    markLesson(watchedLesson) {
      var newWatchedLesson = { lesson_id: "" };
      newWatchedLesson.lesson_id = watchedLesson.id;
      this.axios
        .get("/watched_lesson", newWatchedLesson)
        .then(response => {
          this.axios
            .get("/questions/" + watchedLesson.id)
            .then(response => {
              if(response.data != "empty")
              {
                this.questions = response.data;
                this.answers = {};
                this.modals["centered"] = true;
              }
              else
              {
                this.mark(watchedLesson);
              }
            })
            .catch(error => {
              this.result = "Erro ao enviar avaliaçao. Tente novamente \n. " + error;
              this.closeModal('centered');
              this.openModal('result');
              console.log(error);
            });
        })
        .catch(error => {
          this.result = "Aula já concluída";
          this.closeModal('centered');
          this.openModal('result');
        });
    },
    answerQuestions(watchLesson) {
      this.axios
        .post('/answers', this.answers)
        .then(response => {
          console.log(response.data);
          if(response.data[0] == "approved" || response.data[0] == "repproved")
          {
            if(response.data[0] == "approved")
            {
              this.closeModal('centered');
              this.mark(watchLesson);
              this.result = "Você passou!";
              this.openModal('result');
            }
            else
            {
              this.result = "Você atingiu "+response.data[1]+"% de acerto. Reveja o conteúdo.";
              this.closeModal('centered');
              this.openModal('result');
            }
          }
          else
          {
            this.result = "Você respondeu recentemente e não passou.\n"+"Reveja o conteúdo e tente novamente em " + response.data[1] + " minutos.";
            this.closeModal('centered');
            this.openModal('result');
          }
        })
        .catch(error => {
          console.log(error);
          this.result = "Erro ao enviar resposta. Tente novamente. \n " + error;
          this.closeModal('centered');
          this.openModal('result');
        });
    },
    mark(watchedLesson) {
      if (!this.tempWatchedLesson) {this.tempWatchedLesson = true;}

      if (this.tempWatchedLesson) {
        var newWatchedLesson = { lesson_id: "" };
        newWatchedLesson.lesson_id = watchedLesson.id;
        this.axios
          .post("/watched_lesson", newWatchedLesson)
          .then(response => {
            this.reFetchUserCourses();
          })
          .catch(error => {
            this.result = "Aula já concluída";
            this.closeModal('centered');
            this.openModal('result');
          });
      }
    },
    reviewLesson(watchedLesson, score) {
      this.tempReviewLesson = score;

      var newLessonReview = { lesson_id: "", stars: "" };
      newLessonReview.lesson_id = watchedLesson.id;
      newLessonReview.stars = score;
      this.axios
        .post("/lesson_reviews", newLessonReview)
        .then(response => {
          this.reFetchUserCourses();
        })
        .catch(error => {
          this.closeModal('centered');
          this.result = "Erro ao enviar avaliaçao. Tente novamente. \n " + error;
          this.openModal('result');
          console.log(error);
        });
    },
    downloads() {
      this.openModal("centered");
    }
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    },
    sequence() {
      let lessonIndex = -1;
      let chapterIndex = -1;
      let lessonIndexNoOpcional = -1;
      let chapterIndexNoOpcional = -1;
      let lessonWithOpcional = -1;
      let lessonNoOpcional = -1;
      let lessonsNoOpcional = -1;
      let lessons = [];
      let first = false;
      for (
        let chapter = 0;
        chapter < this.courses[this.courseIndex].chapters.data.length;
        chapter++
      ) {
        lessons = this.courses[this.courseIndex].chapters.data[chapter].lessons.data;
        lessonWithOpcional = _.findIndex(
          lessons,
          function(o) {
            return o.watched === null;
          }
        );
        if (lessonWithOpcional !== -1 && !first) {
          chapterIndex = chapter;
          lessonIndex = lessonWithOpcional;
          first = true;
        }
        lessonNoOpcional = _.findIndex(
          lessonsNoOpcional,
          function(o) {
            return o.watched === null && o.required !== 0;
          }
        );
        if (lessonNoOpcional !== -1) {
          chapterIndexNoOpcional = chapter;
          lessonIndexNoOpcional = lessonNoOpcional;
        } else {
          chapterIndexNoOpcional = -1;
          lessonIndexNoOpcional = -1;
        }
      }
      return { lessonIndex, chapterIndex, lessonIndexNoOpcional, chapterIndexNoOpcional };
    }
  },
  created() {
    this.fetchUserCourses();
  }
};
</script>
<style>
.el-collapse-item__header-black {
  color: #b1e0fc !important;
}
.el-collapse-item__header-light {
  color: #851bdb !important;
}
.cola {
  background: #000 !important;
}
.content-video a{
  color: #0c7cd5;
}
.col-md-6 {
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 100%;
}
#loading {
  min-height: 200px;
  display: flex;
  align-items: center;
.el-loading-spinner .path {
  stroke: #000 !important;
}

.el-loading-mask {
  background: transparent !important;
}
}

#lessonFrame {
  width: 100%;
  height: 600px;
}

@media screen and (max-width: 800px) {
  #lessonFrame {
    width: 100%;
    height: 300px;
  }
}
.el-dialog {
  width: 50%;
  white-space: -moz-pre-wrap; /* Firefox */
  white-space: -o-pre-wrap; /* Opera */
  white-space: pre-wrap; /* Chrome */
  word-wrap: break-word; /* IE */
}
@media (max-width: 800px) {
  .el-dialog {
    width: 90%;
  }
}
input[type="radio"] {
  -ms-transform: scale(1.5); /* IE 9 */
  -webkit-transform: scale(1.5); /* Chrome, Safari, Opera */
  transform: scale(1.5);
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Course.vue